// extracted by mini-css-extract-plugin
export var marginNegative = "_66-5 _66-3 _66-1";
export var marginPositive = "_66-4 _66-3 _66-1";
export var modalContent = "_66-6";
export var samplesTable = "_66-8";
export var samplesTableContainer = "_66-7";
export var statBox = "_66-a";
export var tableCell = "_66-1";
export var tableCellCenter = "_66-2 _66-1";
export var tableCellRight = "_66-3 _66-1";
export var tableHeader = "_66-0";
export var trackingNumber = "_66-9";